import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getStorage } from '../utils/apiUtils';

/**
 * ProtectedRoute component that checks if user is authenticated
 * Redirects to login if token is not present
 */
const ProtectedRoute = ({ children }) => {
  const { anchor } = useParams();
  const token = getStorage('token');
  const defaultAnchor = anchor || localStorage.getItem('anchor') || 'ayushpay';

  // If no token, redirect to login page
  if (!token) {
    return <Navigate to={`/${defaultAnchor}/`} replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;


